// Opens a file input from a tap on an attach button, right away.
//
// Do not try to drop the keyboard first and open the picker after the
// layout settles: WebKit anchors its attach menu (Photo Library / Take Photo
// / Choose Files) to the point that was touched, not to the button's
// position at open time, so a layout shift between the two leaves the menu
// floating mid-screen. Keeping the layout still while the menu is up is the
// native shell's job (SindiWebViewController holds the keyboard inset while
// something is presented over the page).
export function openFilePickerAfterKeyboard(input) {
  input.click()
}
